var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaret = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 9 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.123 4.31 4.5.5.877 4.31a.576.576 0 0 0 0 .793.52.52 0 0 0 .754 0L4.5 2.086l2.869 3.017a.52.52 0 0 0 .754 0 .576.576 0 0 0 0-.793"
})));
export default SvgCaret;